import { GridRenderCellParams } from '@mui/x-data-grid';

export function formatMoneyValue(value: number | null | undefined, currencyId?: number): string {
    const num = value ?? 0;
    switch (currencyId) {
        case 2:
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(num);
        case 3:
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(num);
        case 4:
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(num);
        default:
            return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 }).format(num);
    }
}

export function formatMoney(params: GridRenderCellParams, title: string) {
    switch (params?.row?.currencyId ?? params) {
        case null:
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(params?.row[title]);
        case 1:
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(params?.row[title]);
        case 2:
            return new Intl.NumberFormat('en-US', {
                style: 'currency', currency: 'USD',
                minimumFractionDigits: 2,
            }).format(params?.row[title]);
        case 3:
            return new Intl.NumberFormat('de-DE', {
                style: 'currency', currency: 'EUR',
                minimumFractionDigits: 2,
            }).format(params?.row[title]);
        case 4:
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2,
            }).format(params?.row[title]);

        default:
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(params?.row[title]);
    }


}
